import { SafiVatEnum } from 'api';
import { CountryAutocompleteField, IncotermSelectField, SelectField, TextField, useFormContext } from 'form';
import { useTranslation } from 'i18n';
import { ChangeEvent, useContext } from 'react';
import { SectionContainer } from 'ui';

import { SalesOrderFormContext } from '../../contexts/SalesOrderFormContext';
import { SalesOrderCreateFormValues } from '../../pages/SalesOrderCreate/SalesOrderCreate';

const VAT_OPTIONS = Object.values(SafiVatEnum).map((value) => ({
  label: value,
  value: value,
}));

export const BuyerDealDetailsSection = () => {
  const { t } = useTranslation('orders');
  const { t: commonT } = useTranslation('common');
  const { setValue, getValues } = useFormContext<SalesOrderCreateFormValues>();
  const { variant, defaultValues } = useContext(SalesOrderFormContext);

  const handleTonnesPerLoadChange = (e: ChangeEvent<HTMLInputElement>) => {
    const numberOfLoads = getValues('number_of_loads');
    setValue('tonnes', String(Number(e.target.value) * Number(numberOfLoads)));
  };

  const handleNumberOfLoadsChange = (e: ChangeEvent<HTMLInputElement>) => {
    const tonnesPerLoad = getValues('tonnes_per_load');
    setValue('tonnes', String(Number(e.target.value) * Number(tonnesPerLoad)));
  };

  return (
    <SectionContainer title={t('buyerDealDetailsSection.title')}>
      <IncotermSelectField
        selectableIncoterms={['EXW', 'FOB', 'CFR', 'CIF', 'CPT', 'CIP', 'DAP', 'DDP']}
        infoTooltip={t('buyerDealDetailsSection.incotermTooltip')}
      />
      <TextField
        name="tonnes_per_load"
        label={t('buyerDealDetailsSection.tonnesPerLoadLabel')}
        type="number"
        required
        infoTooltip={t('buyerDealDetailsSection.tonnesPerLoadTooltip')}
        defaultValue={defaultValues?.tonnes_per_load}
        onChange={handleTonnesPerLoadChange}
      />
      <TextField
        label={t('buyerDealDetailsSection.numberOfLoadsLabel')}
        name="number_of_loads"
        type="number"
        required
        infoTooltip={t('buyerDealDetailsSection.numberOfLoadsTooltip')}
        onChange={handleNumberOfLoadsChange}
      />
      {variant === 'create' ? (
        <CountryAutocompleteField
          label={t('buyerDealDetailsSection.collectionAddressCountryLabel')}
          name="collection_address_country"
          required
          infoTooltip={t('buyerDealDetailsSection.collectionAddressCountryTooltip')}
        />
      ) : null}
      {variant === 'update' ? (
        <SelectField name="safi_vat" label={commonT('brand.vatLabel')} options={VAT_OPTIONS} required />
      ) : null}
      <TextField
        type="number"
        name="tonnes"
        label={t('buyerDealDetailsSection.numberOfTonnesLabel')}
        disabled
        infoTooltip={t('buyerDealDetailsSection.numberOfTonnesTooltip')}
      />
    </SectionContainer>
  );
};
